/* =============================================================================
=    Send email verification code
============================================================================= */
import { gql } from 'generated-types/gql';

export default gql(`
mutation subscribeFF91($form: SubscribeFF91Input!) {
  subscribeFF91(subscribeFF91Form: $form) {
    success
  }
}
`);
